import React from 'react';
import PropTypes from 'prop-types';
import { BLACK } from '../../../constants/colors';
import LegendItem from './LegendItem';

const ChartTooltip = ({ data, month }) => {
  return (
    <>
      <div>{month}</div>
      <table style={{ borderCollapse: 'collapse' }}>
        {data.map((item, index) => (
          <tr key={`${index}`}>
            <td>
              <LegendItem
                active
                color={item.color}
                label={item.label}
                style={{
                  margin: '0 10px 3px 1px',
                  color: BLACK,
                }}
              />
            </td>
            <td>
              <div>{item.value}</div>
            </td>
          </tr>
        ))}
      </table>
    </>
  );
};

ChartTooltip.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  month: PropTypes.string,
};

export default ChartTooltip;
